<template>
    <modal :title="$t('public.escalation_rules')" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" label-width="160px" :model="dioForm" :rules="rules">
          <!-- 上报规则 -->
          <el-form-item :label="$t('device.sample_interval')" prop="collectInterval">
              <el-input v-model.trim="dioForm.collectInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
          </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { sensorUpdateNetConfig, magnetismUpdateAppConfig } from '@/api/modules/sensor.js'
import addRules from '@/pages/equipment/validate/addRules.js'
export default {
  name: 'NetParam',
  props: ['isShow', 'choozeTableData', 'useFuncType'],
  watch: {
    choozeTableData (newVal) {
      this.tableData = [...newVal]
    },
  },
  computed: {
    // 正则不会写啊  难搞
    rules () {
      return {
        collectInterval: [
            {
              required: true,
              message: $t('integration.collection_interval_cannot_be_empty'),
              trigger: 'blur'
            }
          ],
      }
    },
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    }
  },
  data () {
    return {
      title: 'public.net_param',
      dioForm: {
        collectInterval: null,
      },
      tableData: []
    }
  },
  mounted () {},
  methods: {
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async handleSave () {
      const flag = await this.justify()
      if (!flag) return
      const idList = this.tableData.map(item => item.id)
      const type = this.tableData[0].type
      const query = Object.assign({}, this.dioForm, { idList })
      // 默认网络参数url
      let httpUrl = magnetismUpdateAppConfig

      // 去除null
      for (const key in query) {
        if (query[key] === null) {
          delete query[key]
        }
      }
      httpUrl(query).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.update_successful'))
          this.isShowDialog = false
          this.$parent.getListFn()
        } else {
          this.$message.error(state.msg)
        }
      })
    }
  }
}
</script>

<style></style>
